"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  color: #556666;\n  margin-bottom: 0.2rem;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inputLabel = void 0;

var _stylitas = require("@creditas/stylitas");

var inputLabel = function inputLabel(_ref) {
  var theme = _ref.theme;
  return (0, _stylitas.css)(_templateObject(), _stylitas.utilities.typography.form(theme));
};

exports.inputLabel = inputLabel;